import axios from "axios";

export function returnNewToken() {
  const token = sessionStorage.getItem("__re_acc_tk");
  axios
    .post(
      `${process.env.VUE_APP_BASEURL_NEW}/api/v1/admin/refresh-token?token=${token}`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      sessionStorage.setItem("__ac_mn_tk", response.data.access_token);
      return;
    })
    .catch((error) => {
      console.log(error);
      return error;
    });
}
